import { logActivity } from 'actions/logs';
import React, { Component } from 'react';
import { translate, Spinner } from '@haldor/ui';
import { connect } from 'react-redux';
import { isMicrosoftTeams } from 'helpers/teams';
import MyPlansWrapper from './MyPlansWrapper';

class Plans extends Component {
	constructor(props) {
		super(props);

		this.state = {
			allowed: undefined,
		};
	}

	componentDidMount() {
		//log the activity of loading the page
		const logJson = { LogType: "Route Change", ReferenceType: "Plans Page", Comment: "User loaded page" };
		this.props.logActivity(logJson);

		this.setState({ allowed: this.props.services.plans });
	}

	render() {
		if (!this.state.allowed) {
			return (
				<div style={{ width: '80%', maxWidth: '625px', margin: '0 auto', textAlign: 'center' }}>
					{this.props.translate('service-not-active-error')}
				</div>
			);
		}
		if (this.state.allowed == undefined) {
			return (
				<Spinner center />
			)
		}

		return (
			<div>
				<MyPlansWrapper />
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		translate: translate(state.Languages.translations),
		services: state.Services.availableServices,
	}
}

export default connect(mapStateToProps, {
	logActivity,
})(Plans);
